module.exports = __webpack_public_path__ + "img/bg_resize_castle_tower.d226c99e.png";